import axiosInstance from './axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const MenuService = {
    // Dish endpoints
    createDish: async (dishData, imageFile) => {
        try {
            const formData = new FormData();

            // Append all dish data
            Object.keys(dishData).forEach(key => {
                if (Array.isArray(dishData[key])) {
                    formData.append(key, JSON.stringify(dishData[key]));
                } else if (typeof dishData[key] === 'object' && dishData[key] !== null) {
                    formData.append(key, JSON.stringify(dishData[key]));
                } else {
                    formData.append(key, dishData[key]);
                }
            });

            // Append image if provided
            if (imageFile) {
                formData.append('dish_Image', imageFile);
            }

            const response = await axiosInstance.post(`${API_BASE_URL}/dishes/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateDish: async (dishId, dishData, imageFile) => {
        console.log(imageFile)
        try {
            const formData = new FormData();

            // Append all dish data
            Object.keys(dishData).forEach(key => {
                if (Array.isArray(dishData[key])) {
                    formData.append(key, JSON.stringify(dishData[key]));
                } else if (typeof dishData[key] === 'object' && dishData[key] !== null) {
                    formData.append(key, JSON.stringify(dishData[key]));
                } else {
                    formData.append(key, dishData[key]);
                }
            });

            // Append image if provided
            if (imageFile) {
                formData.append('dish_Image', imageFile);
            }


            const response = await axiosInstance.put(`${API_BASE_URL}/dishes/${dishId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    deleteDish: async (dishId) => {
        try {
            const response = await axiosInstance.delete(`${API_BASE_URL}/dishes/${dishId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    generateDishImage: async (dishId) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/dishes/${dishId}/generate-image`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Wine endpoints
    createWine: async (wineData, imageFile) => {
        try {
            const formData = new FormData();
            console.log(wineData)

            // Append all wine data
            Object.keys(wineData).forEach(key => {
                if (Array.isArray(wineData[key])) {
                    formData.append(key, JSON.stringify(wineData[key]));
                } else if (typeof wineData[key] === 'object' && wineData[key] !== null) {
                    formData.append(key, JSON.stringify(wineData[key]));
                } else {
                    formData.append(key, wineData[key]);
                }
            });

            // Append image if provided
            if (imageFile) {
                formData.append('wine_Image', imageFile);
            }

            const response = await axiosInstance.post(`${API_BASE_URL}/wines/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateWine: async (wineId, wineData, imageFile) => {
        try {
            const formData = new FormData();

            // Append all wine data
            Object.keys(wineData).forEach(key => {
                if (Array.isArray(wineData[key])) {
                    formData.append(key, JSON.stringify(wineData[key]));
                } else if (typeof wineData[key] === 'object' && wineData[key] !== null) {
                    formData.append(key, JSON.stringify(wineData[key]));
                } else {
                    formData.append(key, wineData[key]);
                }
            });

            // Append image if provided
            if (imageFile) {
                formData.append('wine_Image', imageFile);
            }

            const response = await axiosInstance.put(`${API_BASE_URL}/wines/${wineId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    deleteWine: async (wineId) => {
        try {
            const response = await axiosInstance.delete(`${API_BASE_URL}/wines/${wineId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Get all dishes and wines
    getAllDishes: async (page, limit, query, restaurantId, dishType, status, sortBy, sortOrder) => {
        try {
            // Use search endpoint if any search/filter parameter is provided
            const useSearch = query !== undefined || restaurantId || dishType || status || sortBy;
            const endpoint = useSearch ? `${API_BASE_URL}/dishes/search` : `${API_BASE_URL}/dishes`;

            const response = await axiosInstance.get(endpoint, {
                params: {
                    page,
                    limit,
                    ...(query !== undefined ? { query } : {}),
                    ...(restaurantId ? { restaurantId } : {}),
                    ...(dishType ? { type: dishType } : {}),
                    ...(status ? { status } : {}),
                    ...(sortBy ? { sortBy } : {}),
                    ...(sortOrder ? { sortOrder } : {}),
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getAllWines: async (page, limit, query, restaurantId, wineType, status, btg, btb, sortBy, sortOrder) => {
        try {
            // Use search endpoint if any search/filter parameter is provided
            const useSearch = query !== undefined || restaurantId || wineType || status || btg === true || btb === true || sortBy;
            const endpoint = useSearch ? `${API_BASE_URL}/wines/search` : `${API_BASE_URL}/wines`;

            const response = await axiosInstance.get(endpoint, {
                params: {
                    page,
                    limit,
                    ...(query !== undefined ? { query } : {}),
                    ...(restaurantId ? { restaurantId } : {}),
                    ...(wineType ? { type: wineType } : {}),
                    ...(status ? { status } : {}),
                    ...(btg ? { btg } : {}),
                    ...(btb ? { btb } : {}),
                    ...(sortBy ? { sortBy } : {}),
                    ...(sortOrder ? { sortOrder } : {}),
                },
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    recalculateTrainingStats: async (restaurantUuid) => {
        try {
            const response = await axiosInstance.get(`${API_BASE_URL}/dishes/recalculate-stats/${restaurantUuid}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getAllDeletedWines: async (page, limit, sortBy, sortOrder, query, restaurantId, type) => {
        try {
            // Use search endpoint if query, restaurant, or category is provided
            const useSearch = query !== undefined || restaurantId !== undefined || type !== undefined;
            const endpoint = useSearch ? `${API_BASE_URL}/wines/search` : `${API_BASE_URL}/wines/deleted`;

            const response = await axiosInstance.get(endpoint, {
                params: {
                    ...(page ? { page } : {}),
                    ...(limit ? { limit } : {}),
                    ...(sortBy ? { sortBy } : {}),
                    ...(sortOrder ? { sortOrder } : {}),
                    ...(query !== undefined ? { query } : {}),
                    ...(restaurantId !== undefined ? { restaurantId } : {}),
                    ...(type !== undefined ? { type } : {}),
                    ...(useSearch ? { isDeleteWineSearch: true } : {}),
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getAllDeletedDishes: async (page, limit, sortBy, sortOrder, query, restaurantId, type) => {
        try {
            // Use search endpoint if query, restaurant, or category is provided
            const useSearch = query !== undefined || restaurantId !== undefined || type !== undefined;
            const endpoint = useSearch ? `${API_BASE_URL}/dishes/search` : `${API_BASE_URL}/dishes/deleted`;

            const response = await axiosInstance.get(endpoint, {
                params: {
                    ...(page ? { page } : {}),
                    ...(limit ? { limit } : {}),
                    ...(sortBy ? { sortBy } : {}),
                    ...(sortOrder ? { sortOrder } : {}),
                    ...(query !== undefined ? { query } : {}),
                    ...(restaurantId !== undefined ? { restaurantId } : {}),
                    ...(type !== undefined ? { type } : {}),
                    ...(useSearch ? { isDeleteDishSearch: true } : {}),
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    restoreDish: async (uuid) => {
        try {
            const response = await axiosInstance.put(`${API_BASE_URL}/dishes/restore/${uuid}`);
            return response.data;
        } catch (error) {
            throw error
        }
    },

    restoreWine: async (uuid) => {
        try {
            const response = await axiosInstance.put(`${API_BASE_URL}/wines/restore/${uuid}`);
            return response.data;
        } catch (error) {
            throw error
        }
    },

    restoreDishAsDraft: async (uuid) => {
        try {
            const response = await axiosInstance.put(`${API_BASE_URL}/dishes/restore/${uuid}`, { draft: true });
            return response.data;
        } catch (error) {
            throw error
        }
    },

    restoreWineAsDraft: async (uuid) => {
        try {
            const response = await axiosInstance.put(`${API_BASE_URL}/wines/restore/${uuid}`, { draft: true });
            return response.data;
        } catch (error) {
            throw error
        }
    },

    // Bulk upload function for dishes and wines
    bulkUploadMenu: async (formData, bulkUploadType) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/bulk-upload/create/${bulkUploadType}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error bulk uploading menu items:', error);
            throw error;
        }
    },

    getDishAnalytics: async (restaurant_uuid, status) => {
        try {
            const target = restaurant_uuid || 'all';
            const url = status
                ? `${API_BASE_URL}/dishes/analytics/${target}?status=${status}`
                : `${API_BASE_URL}/dishes/analytics/${target}`;

            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            throw error
        }
    },

    getWineAnalytics: async (restaurant_uuid) => {
        try {
            const target = restaurant_uuid || 'all';
            const response = await axiosInstance.get(`${API_BASE_URL}/wines/analytics/${target}`);
            return response.data;
        } catch (error) {
            throw error

        }
    },

    /**
     * Get paginated dish activity logs for infinite scroll
     * @param {string} restaurant_uuid - Restaurant UUID or 'all'
     * @param {number} page - Page number (default: 1)
     * @param {number} limit - Items per page (default: 20)
     */
    getDishActivity: async (restaurant_uuid, page = 1, limit = 20) => {
        try {
            const target = restaurant_uuid || 'all';
            const response = await axiosInstance.get(`${API_BASE_URL}/dishes/activity/${target}`, {
                params: { page, limit }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Get paginated wine activity logs for infinite scroll
     * @param {string} restaurant_uuid - Restaurant UUID or 'all'
     * @param {number} page - Page number (default: 1)
     * @param {number} limit - Items per page (default: 20)
     */
    getWineActivity: async (restaurant_uuid, page = 1, limit = 20) => {
        try {
            const target = restaurant_uuid || 'all';
            const response = await axiosInstance.get(`${API_BASE_URL}/wines/activity/${target}`, {
                params: { page, limit }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    bulkUpdateDishes: async (dishUuids, action, value) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/dishes/bulk-update`, {
                dish_uuids: dishUuids,
                action,
                value
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    bulkUpdateWines: async (wineUuids, action, value) => {
        try {
            const response = await axiosInstance.post(`${API_BASE_URL}/wines/bulk-update`, {
                wine_uuids: wineUuids,
                action,
                value
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};
